import React from 'react';
import { Box, Typography } from '@mui/material';
import { AppColors } from '../theme/colors';

/**
 * ログアウト後の案内画面（/scan-required）
 *
 * QRから入った利用者がログアウトしたときの着地点。
 *
 * 従来はログイン画面へ戻していたが、QRで入った利用者は会社IDもパスワードも
 * 知らないため（それを不要にするための導線であるため）、入力欄を見せても
 * 何もできない行き止まりになる。
 *
 * 設計書: レフリアメモ/認証の一本化について.md（11章）
 */
export const ScanRequiredPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Box component="img" src="/icon.svg" alt="LiaVoice" sx={{ width: 96, height: 96, mb: 2 }} />
      <Typography
        sx={{
          fontSize: '1.4rem',
          fontWeight: 800,
          color: AppColors.primary,
          letterSpacing: '1.0px',
          fontFamily: '"Nunito", "Noto Sans JP", sans-serif',
          mb: 4,
        }}
      >
        LiaVoice
      </Typography>

      <Box sx={{ textAlign: 'center', maxWidth: 380 }}>
        {/*
          QRを模したアイコンは置かない。読み取れる本物のQRだと誤解され、
          カメラを向けられてしまうため。
        */}
        <Typography sx={{ fontSize: 18, fontWeight: 700, mb: 1.5 }}>
          このURLではご利用いただけません
        </Typography>

        {/*
          この画面はログアウトしたときの着地点。

          「お手元のQRコードを開いてください」という案内は入れていない。
          URLが切り替えられていた場合、手元のQRは既に使えず、案内どおりに
          操作しても開けないため。管理者へ問い合わせる導線に一本化する。

          会社IDとパスワードでのログインへの導線も置かない。この画面に来る
          のはQRから入った利用者であり、パスワードを知らないため。
        */}
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
          ログインの有効期限が切れたか、URLが切り替わっている可能性があります。
          <br />
          続けてご利用になる場合は、管理者へ
          <br />
          最新のQRコード・URLをお問い合わせください。
        </Typography>
      </Box>
    </Box>
  );
};

export default ScanRequiredPage;
